import {commercialWebsocketCommands} from '../../constants/commercialWebsocketCommands';
import {COMMERCIAL_STATISTICS_PENDING} from '../../actions/commercial/actionCommercialStatistics';

export const commercialStatistics = (state = {
    correlationId: '',
    isLoading: false,
    data: [],
}, action) => {
    switch (action.type) {
        case COMMERCIAL_STATISTICS_PENDING: {
            const { correlationId } = action.payload;
            return Object.assign({}, state, {
                isLoading: true, correlationId
            });
        }
        case commercialWebsocketCommands.COMMERCIAL_STATISTICS_SEND: {
            const { correlationId, result: { data } } = action.payload;
            if (correlationId !== state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isLoading: false, correlationId, data
                });
            }
        }
        case commercialWebsocketCommands.COMMERCIAL_STATISTICS_SEND_ERROR: {
            const { correlationId } = action.payload;
            if (correlationId !== state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isLoading: false, correlationId
                });
            }
        }
        default: {
            return state;
        }
    }
};
